// Fetches the composer's Lexical editor chunk once. Composers mounted after it
// arrives render the editor straight away instead of a stand-in.
let loadedEditor = null;
let loading = null;

export function loadComposerEditor() {
	loading ??= import(/* webpackChunkName: "ChatComposerEditor" */ 'react/chat/composer/ChatComposerEditor.jsx')
		.then((module) => {
			loadedEditor = module.default;
			return loadedEditor;
		})
		.catch((error) => {
			// Lets the next composer try again, after a dropped connection say.
			loading = null;
			throw error;
		});
	return loading;
}

export function loadedComposerEditor() {
	return loadedEditor;
}
